
import { useEffect, useMemo, useState } from 'react';
import {  getDefaultValueFromSaved, getFilterSaveDateVal, } from '../util';
import { isEmpty } from 'lodash-es';
import { storage } from '@/utils/utils';
import { DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY, DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY } from '@/pages/dashboard/_config/constant';
import { shallowEqual, useSelector } from 'umi';

export default (props: { value: any; realInputList: any; selector: any; defaultValue: any;gameCode:string,defaultSelectedItem:any,isOutScheme:boolean,filterSaveOnChange:Function }) => {
  const { value,realInputList,selector,defaultValue,gameCode,defaultSelectedItem,isOutScheme,filterSaveOnChange} = props;
  const [filterModalInfo, setFilterModalInfo] = useState({filterModalType:'',filterModalVisible:false});
  const [formValue, setFormValue] = useState(value);
  const [isInit,setIsInit] = useState(true);
  const filterStorageSave = storage.getItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY);
  const filterSaveVal = filterStorageSave ? getFilterSaveDateVal(filterStorageSave) : {};
  const defaultSelectedValue = (!isEmpty(filterSaveVal)) ? filterSaveVal : (defaultSelectedItem ? defaultSelectedItem : {})

  const filterDurationData:any = useSelector((state: any) => {
    return state?.dashboardSetting?.filterDurationData
  }, shallowEqual)
  
  const [selectedValue, setSelectedValue] = useState( {});

  useEffect(() => {
    setFormValue(value)
    //只用value有时候会监听不到，比如在实时页面，切换all country和keycountry的时候，打开地区筛选器，再继续切换
  }, [JSON.stringify(value)])
  
  useEffect(()=>{
    // 限制编辑后引发的defaultSelectedItem变化，导致重新setSelectedValue
    if(!isInit || isEmpty(defaultSelectedValue)) return
    setSelectedValue(defaultSelectedValue)
    setIsInit(false)
  },[JSON.stringify(defaultSelectedValue)])

  const filterSchemeChange = (val: any) => {
    setSelectedValue(val)
    let resultRealInputList = realInputList
    if(filterSaveOnChange) {
      // 竞品这边使用lanch筛选器时，需要重新赋值，其他页面如不需要则直接返回realInputList
      resultRealInputList =  filterSaveOnChange(realInputList, val?.filter_cond)
    }
    const value = getDefaultValueFromSaved(resultRealInputList, val?.filter_cond, defaultValue, selector,filterDurationData);
    setFormValue(value);
  }

  return {
    formValue,
    setFormValue,
    filterSchemeChange,
    selectedValue,
    setSelectedValue,
    filterModalInfo, 
    setFilterModalInfo,
  }
}
